import React from 'react';
import DateRangeMenu from '../../../../shared/designSystem/components/DateRangeMenu';

// =============================================================================
// CampaignRangeSelector — shared page-level range picker shim used by
// Display / Sign Ups (V1+V2) / Sessions (V1+V2).
//
// Migrated from the segmented `<DateRangePicker>` (pills + Custom popover)
// to the modern single-trigger `<DateRangeMenu>` (one labelled pill →
// popover with presets-on-left + calendar-on-right + selected-dates row).
// 2024-25 dashboard convention (Linear / Stripe / GA4 / shadcn-DRP).
//
// API mirrors the prior shim — props pass through; consumer changes none.
// `disabled` is forwarded so consumers that previously gated the picker
// when there was no data can keep doing that. The `setRangeKey` helper
// some Summary-style consumers used is now folded into the consumer's
// own `setRangeType` handler (see SummaryRangeSelector for the pattern).
// =============================================================================
// `disabledDate` (optional): a (current) => boolean forwarded straight to
// DateRangeMenu. When omitted (all consumers except the Display tab today) the
// menu keeps its default clamp to `defaultDateRange`; when supplied it takes
// over — e.g. the Display tab bounds the picker to the campaign flight window
// instead of the delivery-data extent so pre-delivery days stay selectable.
const CampaignRangeSelector = ({
  rangeType,
  byCampaignRangeDate,
  setRangeType,
  setByCampaignRangeDate,
  timezone = 'UTC',
  defaultDateRange,
  disabledDate,
  disabled = false,
}) => {
  return (
    <DateRangeMenu
      rangeType={rangeType}
      onRangeTypeChange={setRangeType}
      value={byCampaignRangeDate}
      onChange={setByCampaignRangeDate}
      defaultDateRange={defaultDateRange}
      disabledDate={disabledDate}
      timezone={timezone}
      disabled={disabled}
    />
  );
};

export default CampaignRangeSelector;
